import React, { useEffect, createElement } from 'react';
export const GoogleTag = () => {
  useEffect(() => {
    // Create first script element (async src)
    const scriptAsync = document.createElement('script');
    scriptAsync.async = true;
    scriptAsync.src = 'https://www.googletagmanager.com/gtag/js?id=AW-649210165';
    // Create second script element (inline code)
    const scriptInline = document.createElement('script');
    scriptInline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-649210165');
    `;
    // Append to head
    document.head.appendChild(scriptAsync);
    document.head.appendChild(scriptInline);
    // Cleanup function
    return () => {
      document.head.removeChild(scriptAsync);
      document.head.removeChild(scriptInline);
    };
  }, []);
  return null; // This component doesn't render anything
};